import { render, staticRenderFns } from "./AchievementInfo.vue?vue&type=template&id=130afe44"
import script from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports